const UAParser = require('ua-parser-js')

const UA = new UAParser()

const DEVICE_TYPES = {
    MOBILE: "mobile",
    TABLET: "tablet",
    SMART_TV: "smarttv",
    CONSOLE: "console",
    WEARABLE: "wearable",
    BROWSER: undefined
};
const MOBILE = DEVICE_TYPES.MOBILE
const TABLET = DEVICE_TYPES.TABLET

const browser = UA.getBrowser()
const os = UA.getOS()
const device = UA.getDevice();

const isMobileAndTabletType = function isMobileAndTabletType() {
    switch (device.type) {
        case MOBILE:
        case TABLET:
            return true;
        default:
            return false;
    }
};


const getNavigatorInstance = () => {
    if (typeof window !== 'undefined') {
        if (window.navigator || navigator) {
            return window.navigator || navigator;
        }
    }

    return false;
};

const isIOS13Check = (type) => {
    var nav = getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform ===
        'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

const getIPad13 = () => {
    return isIOS13Check('iPad');
};

export const isMobile = isMobileAndTabletType() || getIPad13();
export const browserName = browser.name
export const browserVersion = browser.version
export const osName = os.name ? os.name : "none"
